import axios from 'axios';
const { rootUrl } = require('../../../config/config');

export const UNASSIGNED_MANAGER = 'unassigned';

export const staffLabel = (staff) => (staff ? (staff.name && staff.name.trim()) || staff.username : '');

/** Active staff members who can be account managers. */
export async function fetchStaffMembers(token) {
    const response = await axios.get(`${rootUrl}/api/users/staff`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data?.data || [];
}

export function staffOptions(staff) {
    return (staff || []).map((s) => ({ value: s.id, label: staffLabel(s) }));
}

/** Assign one manager to many cars at once. */
export async function bulkAssignAccountManager(token, { plateNos, accountManagerId }) {
    const response = await axios.post(
        `${rootUrl}/cars/account-manager/bulk`,
        { plate_nos: plateNos, account_manager_id: accountManagerId },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
}

export async function fetchAccountManagerHistory(token, plateNo) {
    const response = await axios.get(`${rootUrl}/cars/${encodeURIComponent(plateNo)}/account-manager-history`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data?.data || [];
}

// Seeded to Super Admin (mminder db-logs/128.sql); roles.manage also passes on the API
export const ASSIGN_MANAGER_PERMISSION = 'cars.account_manager.assign';

export const canAssignAccountManagers = (permissions = []) =>
    permissions.includes(ASSIGN_MANAGER_PERMISSION) || permissions.includes('roles.manage');
